import { Component, EventEmitter, Input, input, OnInit, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AccomplishmentService } from 'src/app/services/accomplishment.service';
import { faEdit, faFileLines } from '@fortawesome/free-solid-svg-icons';
import { ReportForest } from 'src/app/models/reportForest.model';

@Component({
  selector: 'app-accomplishments',
  templateUrl: './accomplishments.component.html',
  styleUrls: ['./accomplishments.component.scss'],
  standalone: false
})
export class AccomplishmentsComponent implements OnInit {
  //icons
  faEdit = faEdit;
  faFileLines = faFileLines;

  //data
  @Input() assessment: any;
  @Input() reports: any;
  accomplishment_reports: any;
  canCreate = false;
  totalFunding = 0;
  totalCompletedFunding = 0;

  displayedColumns = [
    'name',
    'action_type',
    'submission_date',
    'submitted_by',
    'status',
    'actions'
  ];

  constructor(
    private readonly router: Router,
    private readonly titleService: Title,
    private readonly accomplishmentService: AccomplishmentService,
  ) {
    this.titleService.setTitle("BAER - Assessments")
  }

  ngOnInit(): void {
    this.getTotalFunding();
    this.accomplishment_reports = [];
    this.accomplishmentService.getAccomplishmentsByAssessmentID(this.assessment.assessment_id).subscribe((accomplishments: any) => {
      this.accomplishment_reports = accomplishments.accomplishments;
      this.getTotalCompletedFunding();
    });
    this.checkForCreate();
  }

  createAccomplishReport() {
    this.accomplishmentService.createAccomplishment(this.assessment.assessment_id).subscribe((response: any) => {
      this.router.navigate(['/report-accomplishment'], { queryParams: { accomplishment_id: response.accomplishment_id, report_page_input: 1 } });
    })
  }

  checkForCreate() {
    this.reports.forEach((report: any) => {
      if (report.authorization_status_id == 4) this.canCreate = true;
    })
  }

  getTotalFunding() {
    let total = 0;
    this.reports.forEach((report: any) => {
        report.forests.forEach((forest: ReportForest) => {
          total += this.forestTotal(forest.treatments);
        });
    })
    this.totalFunding = total;
  }

  forestTotal(treatments: any[] | undefined) {
    let total = 0;
    if (treatments == null) return 0
    for (let item of treatments) {
      total += this.unitTotal(item.treatment_specifications[0]) || 0; // ?? Does not cover NaN
    }
    return total;
  }

  unitTotal(item: any) {
    return (item.approved_unit_cost * item.approved_unit_qty) + (item.wo_approved_unit_cost * item.wo_approved_unit_qty);
  }


  getTotalCompletedFunding() {
    let total = 0;
    let treatmentList: any[] = [];
    let filteredList = this.accomplishment_reports.filter((accomplishment: any) => accomplishment.submitted) //only calculate on submitted
    if (filteredList.length > 0) {
      let lastReport = filteredList[filteredList.length - 1] //calc on last submitted report
      for (let treatment of lastReport.accomplishment_treatments) {
        total += this.calcTotalCompleted(treatment);
      }
    }
    this.totalCompletedFunding = total;
  }

  calcTotalCompleted(treatment: any) {
    const units = treatment.units;
    const spec = treatment.forest_treatment.treatment_specifications[0];
    let total = 0;
    let unitsLeft = units - spec.approved_unit_qty;
    if (unitsLeft > 0) { //leftover gets used against wo approval
      total = (spec.approved_unit_cost * spec.approved_unit_qty) + (spec.wo_approved_unit_cost * units);
    } else { //only use ro ammount. below or equal to approved amount
      total = (spec.approved_unit_cost * units);
    }
    return total;
  }
}